export default __webpack_public_path__ + "static/media/csc_04.a7fa1b1b.png";